import { NgModule } from "@angular/core";

import { FeatherModule } from "angular-feather";
import {
  Activity,
  Monitor,
  AlertCircle,
  User,
  Star,
  ArrowDown,
  ArrowUp,
  MoreHorizontal,
  RefreshCw,
  ArrowRight,
  ExternalLink,
  ArrowLeft,
  HardDrive,
  CheckCircle,
  LifeBuoy,
  Zap,
  Info,
  AlertTriangle,
  XCircle,
} from "angular-feather/icons";

// Select some icons (use an object, not an array)
const icons = {
  Activity,
  Monitor,
  AlertCircle,
  User,
  Star,
  ArrowDown,
  ArrowUp,
  MoreHorizontal,
  RefreshCw,
  ArrowRight,
  ArrowLeft,
  ExternalLink,
  HardDrive,
  CheckCircle,
  LifeBuoy,
  Zap,
  Info,
  AlertTriangle,
  XCircle,
};

@NgModule({
  imports: [FeatherModule.pick(icons)],
  exports: [FeatherModule],
})
export class IconModule {}
